<script>
import { layoutComputed } from '@state/helpers'
import Vertical from '@router/layouts/vertical'
import Horizontal from '@router/layouts/horizontal'

export default {
  components: { Vertical, Horizontal },
  data() {
    return {}
  },
  computed: {
    ...layoutComputed,
  },
  methods: {},
}
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
</template>

<style>
.table th, .table td {
    vertical-align: middle;
}

.table.b-table .btn {
    margin-left: 2px !important;
    margin-right: 2px !important;
    margin-top: 2px !important;
    margin-bottom: 2px !important;    
}

.table.b-table .btn i.uil.uil-pen.mr-1 {
    margin-right: 0px !important;
}

.btn-rounded {
    padding-left: 20px;
    padding-right: 20px;
}

thead {
    font-size: 12px
}

.pro-user-desc {
    text-transform: lowercase !important;
}

.btn-primary:hover {
    background-color: #ffa333 !important;
    border-color: #ffa333 !important;
}

h4 i {
    margin-right: 10px !important;
}

form {
    max-width: 900px !important;
}
.card {
  border: 1px solid #e2e7f1 !important;
  box-shadow: none !important
}
.table.b-table th{
  border-top: none !important
}
.pagination li span, .pagination li button {
  background: none;
}
.page-item.disabled .page-link {
  background: none;
}
.dropdown-menu {
  padding: 0;
}

</style>